import { Renderer2 } from '@angular/core';

export const initObserver = (
  targetElement: Element | null,
  notificationElement: HTMLElement | null,
  onIntersect: (entries: IntersectionObserverEntry[]) => void,
  toggleSticky: (isSticky: boolean) => void
) => {
  if (notificationElement && targetElement) {
    const targetRect = targetElement.getBoundingClientRect();
    const isOutOfView =
      targetRect.bottom < 0 || targetRect.top > window.innerHeight;

    toggleSticky(isOutOfView);

    const observer = new IntersectionObserver(onIntersect, {
      root: null,
      threshold: 0.1
    });

    observer.observe(targetElement);

    return observer;
  } else {
    toggleSticky(true);
    return null;
  }
};

export const cleanupObserver = (observer: IntersectionObserver | null) => {
  if (observer) {
    observer.disconnect();
  }
};

export const toggleStickyClass = (
  notificationElement: HTMLElement | null,
  isSticky: boolean,
  renderer: Renderer2
) => {
  if (notificationElement) {
    if (isSticky) {
      renderer.addClass(notificationElement, 'sticky');
    } else {
      renderer.removeClass(notificationElement, 'sticky');
    }
  }
};
